import { Component, OnInit, EventEmitter } from "@angular/core";
import { NumpadOptions } from "../../../interface/numpad-options";
import { ICloseable } from "../../modal/ICloseable";
import { NumpadComponent } from "../numpad.component";

@Component({
    selector: 'pos-numpad-wrapper',
    templateUrl: './numpad-wrapper.component.html',
    imports: [NumpadComponent]
})
export class NumpadWrapperComponent implements OnInit, ICloseable {

    numpadOption: NumpadOptions;
    close: EventEmitter<any> = new EventEmitter();
    value: any;
    numpadId: string;
    numpadTitle: string;
    ngOnInit() {

    }

    onSubmit = (res) => {
        this.close.emit(res);
    }

    onCancel = (res) => {
        this.close.emit({});
    }
}
